// Affiliate attribution arrives as ?transaction_id={clickId}-{campaignId}-{publisherId}.
// clickId may itself contain '-', so campaignId and publisherId are taken from the right.
export default function getCampaignParametersFromUrl() {
  const transactionId = new URLSearchParams(window.location.search).get('transaction_id')
  if (!transactionId) return { transactionId: null, clickId: null, campaignId: null, publisherId: null }

  const parts = transactionId.split('-')
  const publisherId = parts.pop() ?? null
  const campaignId = parts.pop() ?? null
  const clickId = parts.join('-') || null

  return { transactionId, clickId, campaignId, publisherId }
}
